import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { ClipboardCheck } from "lucide-react";

export default function AtlasChecklistsTable() {
  const { t, messages } = useI18n();
  const rows = messages?.checklistsTable?.rows || [];
  return (
    <section
      id="checklists-personalizados"
      data-testid="atlas-checklists-table"
      className="py-16 lg:py-24 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-[#6B46C1] uppercase tracking-[0.18em] text-xs font-bold">
          <ClipboardCheck size={14} />
          <span>{t("checklistsTable.badge")}</span>
        </div>
        <h2
          data-testid="checklists-title"
          className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] leading-tight font-extrabold text-slate-900"
        >
          {t("checklistsTable.titleA")}{" "}
          <span className="text-[#6B46C1]">{t("checklistsTable.titleB")}</span>
        </h2>
        <p className="mt-3 text-slate-600 text-base sm:text-lg max-w-2xl">
          {t("checklistsTable.subtitle")}
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl ring-1 ring-slate-200 shadow-sm bg-white">
          <table
            data-testid="checklists-table"
            className="w-full text-left border-collapse"
          >
            <thead className="bg-slate-900 text-white">
              <tr>
                <th className="px-4 sm:px-6 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider w-1/4">
                  {t("checklistsTable.colType")}
                </th>
                <th className="px-4 sm:px-6 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider w-1/3">
                  {t("checklistsTable.colExample")}
                </th>
                <th className="px-4 sm:px-6 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider">
                  {t("checklistsTable.colBenefit")}
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr
                  key={i}
                  data-testid={`checklists-row-${i}`}
                  className={`${
                    i % 2 === 0 ? "bg-white" : "bg-slate-50/70"
                  } transition-colors hover:bg-[#6B46C1]/[0.06] border-t border-slate-200`}
                >
                  <td className="px-4 sm:px-6 py-4 align-top text-slate-900 font-semibold text-[15px] sm:text-base">
                    {r.type}
                  </td>
                  <td className="px-4 sm:px-6 py-4 align-top text-slate-700 text-sm sm:text-[15px] leading-relaxed">
                    {r.example}
                  </td>
                  <td className="px-4 sm:px-6 py-4 align-top text-slate-600 text-sm sm:text-[15px] leading-relaxed">
                    {r.benefit}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
